import React, { useState, useEffect } from 'react'
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  IconButton,
  TextField,
  CircularProgress,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import RecruiterCard from './RecruiterCard'
import { fetchRecruiterList } from '../../api/recruiterApi'
import { fetchToolsList } from '../../api/toolsApi'

const RecruiterModal = ({
  open,
  onClose,
  allRecruiters,
  selected,
  onSave,
  label = '',
  allItems,
  setAllItems
}) => {
  // const [allItems, setAllItems] = useState([])
  const [localList, setLocalList] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!open) return

    if (allRecruiters && Array.isArray(allRecruiters) && allRecruiters.length > 0) {
      setAllItems(allRecruiters)
      setLoading(false)
      return
    }

    setLoading(true)
    let fetchFn
    if (label.includes('Tools')) {
      fetchFn = fetchToolsList
    } else {
      fetchFn = fetchRecruiterList
    }
    Promise.resolve(fetchFn())
      .then((items) => setAllItems(items || []))
      .finally(() => setLoading(false))
  }, [open, label, allRecruiters, label])

  useEffect(() => {
    setLocalList(Array.isArray(selected) ? selected : [])
  }, [selected, open])

  const toggleItem = (item) => {
    const id = item.value || item._id || item.toolId
    const exists = localList.some(r => (r.value || r._id || r.toolId) === id)
    if (exists) {
      setLocalList(localList.filter(r => (r.value || r._id || r.toolId) !== id))
    } else {
      setLocalList([...localList, item])
    }
  }

  const handleSave = () => {
    onSave(Array.isArray(localList) ? localList : [])
    onClose()
  }

  const filteredItems = allItems.filter(r =>
    ((r.label || r.name || r.toolName || '') + '')
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  )

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'relative',
          bgcolor: 'white',
          p: 3,
          width: '90%',
          maxWidth: 1200,
          maxHeight: '90vh',
          overflow: 'hidden',
          mx: 'auto',
          mt: 5,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            backgroundColor: '#f0f0f0',
            '&:hover': { backgroundColor: '#e0e0e0' },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography sx={{ fontSize: '18px', fontWeight: 'bold', color: '#15243E' }} mb={2}>
          {label.includes('Tools') ? 'Select Tools/Technologies' : 'Select Top Recruiters'}
        </Typography>

        <TextField
          placeholder={`Search ${label.includes('Tools') ? 'technology name...' : 'company name...'}`}
          variant="outlined"
          size="small"
          fullWidth
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          sx={{
            mb: 2,
            '& .MuiInputBase-root': { height: 40, borderRadius: 20, fontSize: '14px' },
            '& input': { fontSize: '14px', padding: '8px 12px' },
          }}
          InputProps={{
            endAdornment: (
              <SearchIcon sx={{ color: '#9e9e9e', mr: 1 }} />
            )
          }}
        />

        <Box sx={{ flex: 1, overflowY: 'auto', pr: 1 }}>
          {loading ? (
            <Box textAlign="center" py={4}>
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Grid container spacing={2}>
              {filteredItems.length > 0 ? (
                filteredItems.map((r, index) => {
                  const id = r.value || r._id || r.toolId
                  const isSelected = !!localList.find(i => (i.value || i._id || i.toolId) === id)
                  return (
                    <Grid item xs={12} sm={6} md={4} key={id || index}>
                      <RecruiterCard
                        name={r.label || r.name || r.toolName}
                        logo={r.image || r.logo || r.toolLogo}
                        onRemove={() => toggleItem(r)}
                        removeLabel={isSelected ? "Remove" : "Add"}
                        selected={isSelected}
                      />
                    </Grid>
                  )
                })
              ) : (
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: 'gray' }}>
                    No items found.
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </Box>

        <Box mt={2} textAlign="right">
          <Button variant="contained" onClick={handleSave}>Save</Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default RecruiterModal